import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../http-services/auth.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
    private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        this.authService.logout();
        this.router.navigate(['/login']);
      }
      else if (err.status === 0) {
        //SERVER IS DOWN
        return throwError('Request timed out');
      }


      const error = err.error || err.message || err.error.message || err.statusText;

      //HANDLE EMAIL ERROR
      //if((request.url.includes('registerconsumeruser') || request.url.includes('/Tokens/sign-in')) && err.error.EmailAddress)
      if (err.error.EmailAddress) {
        return throwError(err.error.EmailAddress);
      }

      //HANDLE PASSWORD ERROR
      if (err.error.Password) {
        return throwError(err.error.Password);
      }

      return throwError(error);
    }))
  }
}
